import type React from 'react';

export interface IProps {
  isActive: boolean;
}

const ClickUserProfileStatus: React.FC<IProps> = ({ isActive }: { isActive: boolean }) => {
  if (isActive)
    return (
      <div className="rounded-xl bg-green-100 px-5 py-1.5 text-xs font-bold text-green-800">
        Active
      </div>
    );
  else {
    return (
      <div className="rounded-xl bg-red-100 px-5 py-1.5 text-xs font-bold text-red-800">
        Inactive
      </div>
    );
  }
};

ClickUserProfileStatus.displayName = 'ClickUserProfileStatus';

export default ClickUserProfileStatus;
